import { Menu } from "lucide-react";
import { usePageTitle } from "./usePageTitle";

interface MobileHeaderProps {
	onMenuClick: () => void;
}

export function MobileHeader({ onMenuClick }: MobileHeaderProps) {
	const title = usePageTitle();

	return (
		<header className="sticky top-0 z-40 flex h-14 items-center border-b border-border bg-background px-4 xl:hidden">
			{/* Left slot — empty for balance */}
			<div className="w-10" />
			<h1 className="flex-1 text-center text-sm font-semibold">{title}</h1>
			<button
				onClick={onMenuClick}
				className="flex h-10 w-10 items-center justify-center rounded-lg transition-colors duration-150 hover:bg-accent active:scale-95"
				aria-label="Open navigation menu"
			>
				<Menu className="h-5 w-5" aria-hidden="true" />
			</button>
		</header>
	);
}
